import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AwaitModules, Grid, LL_H_C, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { exists, removeDBObjectKeys, StaticLogger, voidFunction } from '@nu-art/ts-common';
import { DropDown_Reference, ModuleFE_Reference, resolveReferenceDisplay } from '@app/hcs-frontend';
import './Editor_MultiVar_References.scss';
import { Dialog_Confirmation, ICONS } from '@app/styles';
import { Preview_Reference } from '@app/hcs-frontend/ui/_previews/index';
import { ModuleFE_MultiVar } from '../../../../../../../_entity.js';
const onReferenceDelete = (multiVarId, reference) => {
    Dialog_Confirmation.show({
        header: 'Delete Reference',
        content: 'Are you sure you want to delete this reference?',
        buttons: [{
                label: 'Delete',
                isPreferred: false,
                action: async () => {
                    try {
                        await ModuleFE_MultiVar._v1.deleteReference({
                            multiVarId,
                            referenceId: reference._id,
                        }).executeSync();
                    }
                    catch (err) {
                        StaticLogger.logError('Field_Reference', 'Failed deleting reference from multi var', err);
                    }
                },
            }, {
                label: 'Cancel',
                isPreferred: true,
                action: voidFunction,
            }]
    });
};
const Field_Reference = (props) => {
    const reference = ModuleFE_Reference.cache.unique(props.editable.item);
    return _jsxs(Grid, { className: 'e__multi-var-reference', children: [props.editMode && exists(reference) && _jsxs(LL_H_C, { className: 'e__multi-var-reference__actions', children: [_jsx(ICONS.advisor_avn_edit.component, { className: 'edit', onClick: () => Preview_Reference.show(reference._id, true) }), _jsx(ICONS.bin.component, { className: 'delete', onClick: () => onReferenceDelete(props.multiVarId, reference) })] }), _jsx(TS_PropRenderer.Horizontal, { label: 'Type', children: _jsx("div", { className: 'e__multi-var__general-value', children: reference?.type ?? 'N/A' }) }), _jsx(TS_PropRenderer.Horizontal, { label: 'Label', children: _jsx("div", { className: 'e__multi-var__general-value', children: reference ? resolveReferenceDisplay(reference) : 'N/A' }) })] });
};
const Field_References = (props) => {
    return props.editable.item.map((_, index) => {
        const editable = props.editable.editProp(index, '');
        editable.setOnDelete(async () => props.editable.removeArrayItem(index));
        return _jsx(Field_Reference, { editable: editable, editMode: props.editMode, multiVarId: props.multiVarId }, _);
    });
};
const Field_AddReference = (props) => {
    if (!props.editMode)
        return;
    const allowedRefIds = new Set(props.profileReferenceIds);
    const currentRefIds = new Set(props.editable.item);
    return _jsx(DropDown_Reference.selectable, { queryFilter: ref => allowedRefIds.has(ref._id), onSelected: ref => {
            if (ref.type !== 'book')
                return props.editable.updateArrayAt(ref._id);
            Preview_Reference.copy(removeDBObjectKeys(ref), ref => {
                if (currentRefIds.has(ref._id))
                    return;
                try {
                    props.editable.updateArrayAt(ref._id);
                    currentRefIds.add(ref._id);
                }
                catch (err) {
                    StaticLogger.logError('Field_AddReference', 'Could not connect ref to multi-var');
                }
            });
        } });
};
export const Editor_MultiVar_References = (props) => {
    const className = _className('e__multi-var__references', props.editMode && 'edit-mode');
    const editable = props.editable.editProp('referenceIds', []);
    return _jsx(AwaitModules, { modules: [ModuleFE_Reference], children: _jsxs(LL_H_C, { className: className, children: [_jsx(Field_References, { editable: editable, editMode: props.editMode, multiVarId: props.editable.item._id }), _jsx(Field_AddReference, { editable: editable, editMode: props.editMode, profileReferenceIds: props.profileReferenceIds })] }) });
};
//# sourceMappingURL=Editor_MultiVar_References.js.map